import { COMPANY_LOGO_PATH, COMPANY_NAME } from '../config/brand';

export function AuthBrand() {
  return (
    <div className="flex items-center justify-center gap-3 mb-8">
      <img
        src={COMPANY_LOGO_PATH}
        alt={`${COMPANY_NAME} Logo`}
        width={56}
        height={56}
        className="w-14 h-14 object-contain"
      />
      <span className="text-2xl font-bold text-foreground">Tyaus Auth</span>
    </div>
  );
}
